import React, { useState } from "react";
import { FaRegCircleCheck } from "react-icons/fa6";

export default function Shipping() {
  const [activeStep, setActiveStep] = useState(1);

  return (
    <div className="shipping">
      <div className="step-container mt-4">
        <div className="steps flex justify-center space-x-4 mt-8">
          <div className="step_btn">
            <button
              className={`step ${activeStep === 1 ? "active" : ""}`}
              disabled={activeStep === 1}
              onClick={() => setActiveStep(1)}
            >
              1
            </button>
            <p>
              In Process <br />
              <span>2-3 Days</span>
            </p>
          </div>
          <div className="step_btn">
            <button
              className={`step ${activeStep === 2 ? "active" : ""}`}
              disabled={activeStep < 2}
              onClick={() => setActiveStep(2)}
            >
              2
            </button>
            <p>
              Shipping <br />
              <span>2-3 Days</span>
            </p>
          </div>
          <div className="step_btn">
            <button
              className={`step ${activeStep === 3 ? "active" : ""}`}
              disabled={activeStep < 3}
              onClick={() => setActiveStep(3)}
            >
              3
            </button>
            <p>
              Signed & Received <br />
              <span>2-3 Days</span>
            </p>
          </div>
        </div>
        <div className="step-content">
          {activeStep === 1 && (
            <>
              <div className="card">
                <FaRegCircleCheck className="icons" size={30} />
                <div className="text_area">
                  <h4>View Details</h4>
                  <p className="mt-2">
                    Track your order's shipping status, carrier, and estimated
                    delivery date.
                  </p>
                </div>
                <button className="btn">Click Here</button>
              </div>
            </>
          )}
          {activeStep === 2 && <div className="accounts"></div>}
          {activeStep === 3 && <div className="credit_review_send"></div>}
        </div>
      </div>
    </div>
  );
}
